var map = {
	"./Yoyo_3121.jpg": 825,
	"./Yoyo_3206.jpg": 826,
	"./Yoyo_3621.jpg": 827,
	"./Yoyo_4422.jpg": 828,
	"./Yoyo_5521.jpg": 829,
	"./Yoyo_5913.jpg": 830,
	"./Yoyo_6443.jpg": 831,
	"./Yoyo_6611.jpg": 832,
	"./Yoyo_6932.jpg": 833,
	"./Yoyo_8000.jpg": 834,
	"./Yoyo_8220.jpg": 835,
	"./Yoyo_8440.jpg": 836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;